<template>
  <div>
    <b-form class="needs-validation"
            >

      <b-row>
        <b-col xl="5" lg="5" sm="5">
          <p class="mt-3">
            <span class="h3">Subscriber Number (MSISDN)</span>
          </p>
        </b-col>
        <b-col xl="7" lg="7" sm="7">
          <b-form-group
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              :state="msisdnStatus"
              v-model="topOffPlansForm.msisdn"
            ></b-form-input>
            <b-form-invalid-feedback :state="msisdnStatus">
              Please enter a valid subscriber number.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="5" lg="5" sm="5">
          <p class="mt-3">
            <span class="h3">Data Plan (TopOff)</span>
          </p>
        </b-col>
        <b-col xl="7" lg="7" sm="7">
          <b-form-group label-for="input-1">
            <b-form-select
              id="period"
              v-model="topOffPlansForm.dataPlan"
              :options="dataPlanOption"
              :state="dataPlanStatus"
              value-field="key"
              text-field="label"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <div class="mt-3 d-flex justify-content-between">
        <base-button type="white" title="Close"  v-on:click="modalClose()">
          Close
        </base-button>
        <base-button type="primary" title="Search"  v-on:click="topOffPlansSubmit" :loading="submitLoading">
          Submit
        </base-button>
      </div>
    </b-form>

  </div>
</template>

<script>
  import administratorService from "../../common/api-services/administrator-service";
  import handleResponse from "../../common/directive/handlResponse";

  export default {
    name: "Top-Off-Plans",
    computed: {
      msisdnStatus() {
        return this.topOffPlansForm.msisdn.length > 0
      },
      dataPlanStatus() {
        return this.topOffPlansForm.dataPlan.length > 0
      }
    },
    data() {
      return {
        topOffPlansForm: {
          msisdn: '',
          dataPlan: '2'
        },
        dataPlanOption: [],
        editStatus: false,
        submitLoading: false
      }
    },
    mounted() {
      this.$root.$on('editMobileDataInfo', (res => {
        this.topOffPlansForm.msisdn = res
      }))
      this.getDataPlanFunc()
    },
    methods: {
      getDataPlanFunc() {
        this.dataPlanOption = []
        administratorService.getDataPlans().then(res => {
          res.map(item => {
            let items = {key: item.amount, label: item.description};
            this.dataPlanOption.push(items)
          })
        })
      },

      modalClose() {
        this.$bvModal.hide('top-off-plans');
      },

      topOffPlansSubmit() {
        if (this.msisdnStatus && this.dataPlanStatus) {
          this.submitLoading = true;
          this.addTopOffPlans('addTopOffOCS')
        }
      },

      addTopOffPlans(method) {
        administratorService.addTopOffOCS(method, this.topOffPlansForm).then(res => {
          this.submitLoading = false;
          let {type, msg} = handleResponse.apiResponse(res);
          this.$toast(JSON.parse(msg) + ' MSISDN ' + this.topOffPlansForm.msisdn, {type: type})
          this.$root.$emit('checkMobileSubscriber', true)
          this.modalClose();
        })
      }
    }
  }
</script>

<style scoped>

</style>
